/*
 * @Author: xxx
 * @Date: 2023-03-16 13:32:58
 * @LastEditors: xxx
 * @LastEditTime: 2023-03-16 15:09:42
 * @Description:关于我们
 */
import request from "@/utils/request";

// 案例列表
export function getCaseList(params?: any) {
  params.type = "1";
  return request({
    url: "https://hztbc.com/news/list_api.php?action=list&type=1",
    method: "get",
    params
  });
}

// 案例详情
export function getCaseDetail(params?: any) {
  return request({
    url: "https://hztbc.com/news/list_api.php?action=info&type=1",
    method: "get",
    params
  });
}

// 动态列表
export function getNewsList(params?: any) {
  return request({
    url: "https://hztbc.com/news/list_api.php?action=list&classid=36",
    method: "get",
    params
  });
}

// 动态详情
export function getNewsDetail(params?: any) {
  return request({
    url: "https://hztbc.com/news/list_api.php?action=info&id=36",
    method: "get",
    params
  });
}

// 公开课列表
export function getCourseList(params?: any) {
  return request({
    url: "https://api.eweixue.com/v1/organization/course/go_enroll",
    method: "get",
    params
  });
}

// 公开课详情
export function getCourseDetail(params?: any) {
  return request({
    url: "https://api.eweixue.com/v1/course/new_detail",
    method: "get",
    params
  });
}

// 添加leads
export function addOpenLeads(data?: any) {
  return request({
    url: "msi/hztbc/add_open_leads.php",
    method: "post",
    data
  });
}
